import { BACKEND_ROUTES } from "../../backendRoutes";
import useSWRImmutable from "swr/immutable";

export const useAcquisitionVectors = () =>
    useSWRImmutable(
        `${BACKEND_ROUTES.ACQUISITION_VECTOR}?sensor=true&sort=name`
    );
